
import moment from "moment";

export const SuperMoment = {

    /**
     * Enumères tous les jours entre les deux dates et renvoie un array<moment.Moment>
     * @param startDate la date de départ
     * @param endDate la date de fin 
     * @param granularity par défaut, c'est un jour, mais on peut choisir n'importe quelle unité de moment.js
     */
    enumerateDaysBetweenDates: (startDate: moment.Moment, endDate: moment.Moment, granularity:moment.unitOfTime.Diff = "days"): moment.Moment[] => {
        const dates = [];

        const currDate = moment(startDate).startOf('day');
        const lastDate = moment(endDate).startOf('day');

        dates.push(currDate.clone());
        while (currDate.add(1, granularity).diff(lastDate, granularity) < 1) {
            dates.push(currDate.clone());
        }

        return dates;
    },

     /**
     * Retourne l'age [ans, mois] 
     * @param birthday la date d'anniversaire
     * @param fromDate la date du jour ( par défaut : aujourd'hui )
     */
    getAge( birthday:moment.Moment, fromDate:moment.Moment = moment() ):Array<number> {
        const age = +fromDate.diff(birthday, 'years', true);
        const decimal = age % 1
        const year_old = Math.floor(age)
        const year_month = Math.floor(12 * decimal)
        return [year_old, year_month]
    }

}